function Header() {
  return (
    <header className="app-header">
      <a href="https://www.tejajajam.com">
        <img src="logo.png" alt="logo" />
      </a>
      <h1>Quiz</h1>
    </header>
  );
}

export default Header;
